import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { logger as _logger } from '../utils/logger';

/**
 * Custom hook to handle language-aware rendering
 * Eliminates duplicate language change detection code across components
 *
 * @param {string} componentName - Name of the component for logging
 * @returns {number} languageRenderKey - Key that changes when language changes
 */
export const useLanguageAwareRender = (componentName = 'Component') => {
  const { currentLanguage, renderTrigger } = useLanguage();
  const [languageRenderKey, setLanguageRenderKey] = useState(Date.now());

  useEffect(() => {
    // Force re-render when language changes
    setLanguageRenderKey(Date.now());
    // logger.debug('useLanguageAwareRender', `${componentName} detected language change, re-rendering`);
  }, [currentLanguage, renderTrigger, componentName]);

  return languageRenderKey;
};

export default useLanguageAwareRender;
